<template>
    <v-dialog v-model="showDialog" max-width="750px" :retain-focus="false">
      <!-- Mientras se carga se muestra el skeleton loader -->
      <template v-if="loading">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </template>
      <template v-else>
        <v-card @wheel="onWheel">
          <v-card-title style="padding: 10px 0 0 10px; height: 20px; margin-bottom: 1rem;">
            <v-col cols="12">
              <span style="font-size: 20px;">
                {{ $t('wkt.admin.messages.survey-window.title') }}
              </span>
            </v-col>
          </v-card-title>

          <v-row style="margin-top: 20px; margin-left: 0; margin-right: 0">
            <v-col cols="12" style="padding: 30px;">
              <div style="display: flex; justify-content: space-between; align-items: baseline">
                <div>{{ txtOpcion1 }}</div>
                <div>{{ txtTotalOpcion1 }}</div>
                <div>{{ txtOpcion2 }}</div>
                <div>{{ txtTotalOpcion2 }}</div>
                <div>
                  <v-btn text @click="onPollPdfClick(payload)">
                    <span style="color: rgb(24, 94, 169); margin-right: 3px;">{{ $t('wkt.admin.common.reports.export_pdf') }}</span>
                    <v-icon color="rgb(24, 94, 169)">picture_as_pdf</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-card-text style="overflow-y: hidden; flex: 1 1 auto; padding-bottom: 0;">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 250px;">
                        {{ $t('wkt.admin.messages.survey-window.table.headers.date') }}
                      </th>
                      <th class="text-left" style="width: 250px;">
                        {{ $t('wkt.admin.messages.survey-window.table.headers.name') }}
                      </th>
                      <th class="text-left">
                        {{ $t('wkt.admin.messages.survey-window.table.headers.answer') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in data" :key="item.responseDate">
                      <td style="width: 250px;">{{ formatLongDateTime(item.responseDate) }}</td>
                      <td style="width: 250px;">{{ item.lastname }}, {{ item.firstname }}</td>
                      <td>{{ item.response }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
          </v-card-text>

          <v-divider style="margin-top:10px"></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="doCancel" style="font-size: 0.9em; font-weight: 400;">
              {{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
</template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'

export default {
  name: 'ResponseMessageDialog',
  mixins: [BaseModule],
  data() {
    return {
      showDialog: false,
      loading: true,
      payload: null,
      data: [],
      sentMessage: {},
      txtOpcion1: null,
      txtOpcion2: null,
      txtTotalOpcion1: null,
      txtTotalOpcion2: null,
      loadingMessageId: true,
      loadingMessageResponses: true
    }
  },
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    open(action, payload) {
      this.payload = payload;
      this.loading = true;
      this.loadingMessageId = true;
      this.loadingMessageResponses = true;
      this.showDialog = true;
      
      this.getMessagesId(payload);
      this.getMessage(payload);
    },
    doCancel() {
      this.showDialog = false;
      this.$emit('canceled', this.payload);
    },
    onPollPdfClick(messageId) {
        gwt.downloadFile(`report/pollRequest/${messageId}`, `poll-report-${messageId}.pdf`);
    },
    // Obtiene la cabecera del mensaje (para títulos, etc.)
    getMessagesId(payload) {
      api.getMessageById(payload, res => {
        this.sentMessage = res;
        this.txtOpcion1 = res.action1Title;
        this.txtOpcion2 = res.action2Title;
        this.loadingMessageId = false;
        this.checkIfLoadingComplete();
      }, error => {
        this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
        this.loadingMessageId = false;
        this.checkIfLoadingComplete();
      });
    },
    // Obtiene las respuestas del mensaje
    getMessage(payload) {
      api.getMessageResponses(payload, res => {
        this.data = res;
        this.setData(res);
        this.loadingMessageResponses = false;
        this.checkIfLoadingComplete();
      }, error => {
        this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
        this.loadingMessageResponses = false;
        this.checkIfLoadingComplete();
      });
    },
    checkIfLoadingComplete() {
      if (!this.loadingMessageId && !this.loadingMessageResponses) {
        this.loading = false;
      }
    },
    // Procesa los mensajes para contar las respuestas y asignar totales
    setData(messages) {
      let count1 = 0;
      let count2 = 0;
      for (let i = 0; i < messages.length; i++) {
        const response = messages[i].response;
        if (!response) {
          continue;
        }
        if (this.sentMessage.action1Target !== null && response.localeCompare(this.sentMessage.action1Target) === 0) {
          count1++;
        } else if (this.sentMessage.action2Target !== null && response.localeCompare(this.sentMessage.action2Target) === 0) {
          count2++;
        }
      }
      this.txtTotalOpcion1 = count1.toString();
      this.txtTotalOpcion2 = count2.toString();
    }
  }
}
</script>